// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__33Z2I","content":"GlobalSearch_content__2nOS2"};